<template>
  <div>
    <v-layout column wrap>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">CDA REGISTER MEMBER</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-flex xs12 class="mx-2 pt-6">
          <v-layout row wrap class="align-center">
            <v-flex xs12 md4>
              <v-combobox
                class="mt-6 mx-4"
                :append-icon="icons.mdiAccountSearchOutline"
                v-model="search"
                @keyup.enter="searching($event.target.value)"
                @change="get_search_items_info"
                :items="search_items"
                item-value="id"
                item-text="name"
                placeholder="Search by (Account Name/Account #)"
                ref="memberCombobox"
                dense
                outlined
              ></v-combobox>
            </v-flex>
            <v-flex xs12 md4>
              <v-btn
                color="primary"
                class="me-3"
                @click="save_bank_details"
                v-if="!saving"
              >
                Save changes
              </v-btn>
              <v-progress-circular
                :size=50
                :width="5"
                color="primary"
                indeterminate
                v-else
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-data-table
          class="pt-6"
          :headers="headers"
          :items="list_of_loan_savings"
          :loading="data_table_loading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <span class="headline">TOTAL: {{ total }}</span>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <span
                v-if="list_of_loan_savings.length>0">
                                                Print Data
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print()"
                                                >
                                                {{ icons.mdiPrinter }}
                                                </v-icon>
                                            </span>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item="{ item }">
            <tr
              @click="activerow(item)"
              :class="{'info black--text': item.id===selectedDepositId}"
            >
              <td>
                {{
                  list_of_loan_savings
                    .map(function (x) {
                      return x.id
                    })
                    .indexOf(item.id) + 1
                }}
              </td>
              <td>
                {{ item.full_name }}
              </td>
              <td class="text-center">
                {{ item.personal_ledger?item.personal_ledger.no_of_shares:'' }}
              </td>
              <td class="text-center">
                {{ item.personal_ledger?item.personal_ledger.amount_subscribed :''}}
              </td>
              <td class="text-center">
                {{ item.personal_ledger?item.personal_ledger.no_of_shares_paid :''}}
              </td>
              <td class="text-center">
                {{ item.personal_ledger?item.personal_ledger.amount_paid_subscribed :''}}
              </td>
            </tr>
          </template>
          </tr>
        </v-data-table>
      </v-card>
    </v-layout>
    <v-dialog v-model="can_edit" persistent width="70%">
      <v-form ref="form" class="multi-col-validation mt-6">
        <v-card flat>
          <v-toolbar dense dark color="primary">
            <v-toolbar-title><h4 class="font-weight-light">ADD PAID UP</h4>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-col
              md="4"
              cols="12"
            ></v-col>
            <v-row>
              <v-col
                md="3"
                cols="12"
              >
                <v-text-field
                  v-model="no_of_share"
                  label="No. of Share"
                  dense
                  outlined
                  type="number"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="3"
                cols="12"
              >
                <v-text-field
                  v-model="no_of_share_sub"
                  label="No. of Share Subscribed"
                  dense
                  outlined
                  type="number"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="3"
                cols="12"
              >
                <v-text-field
                  v-model="no_of_shares_paid"
                  label="No. of Share Paid"
                  dense
                  outlined
                  type="number"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="3"
                cols="12"
              >
                <v-text-field
                  v-model="amount_paid_subscribed"
                  label="Paid Up"
                  dense
                  outlined
                  type="number"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="4"
                cols="12"
              >
                <v-text-field
                  v-model="or_date"
                  label="Date"
                  dense
                  outlined
                  type="date"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="4"
                cols="12"
              >
                <v-text-field
                  v-model="or_no"
                  label="Invoice #"
                  dense
                  outlined
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
              <v-col
                md="4"
                cols="12"
              >
                <v-text-field
                  v-model="amount"
                  label="Amount"
                  dense
                  outlined
                  type="number"
                  :min="0"
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-col cols="12" v-show="alert">
              <v-alert
                color="warning"
                text
                class="mb-0"

              >
                <div class="d-flex align-start">
                  <v-icon color="warning">
                    {{ icons.mdiAlertOutline }}
                  </v-icon>

                  <div class="ms-3">
                    <p class="text-base font-weight-medium mb-1">
                      {{ alert_message }}
                    </p>
                  </div>
                </div>
              </v-alert>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="save_bank_details2"
              v-if="!saving"
            >
              Save changes
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
            <v-btn class="me-3 mt-4" color="error" @click="can_edit=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'
import {mdiAccountSearchOutline, mdiPrinter, mdiPencil} from '@mdi/js'
import moment from "moment";

export default {
  setup() {
    return {
      icons: {
        mdiAccountSearchOutline,
        mdiPrinter,
        mdiPencil,
      },
    }
  },
  data() {
    return {

      search: '',
      search_member: '',
      search_items: [],

      saving: false,
      alert: false,
      alert_message: '',

      or_date: '',
      or_no: '',
      amount: 0,
      no_of_share: 0,
      no_of_share_sub: 0,
      no_of_shares_paid: 0,
      amount_paid_subscribed: 0,
      particulars: '',
      particulars_items: [],


      can_edit: false,
      selected_month_of: 'NA',
      category: '',
      month_of_items: [],
      selected_details: {},
      member_information: {},
      month_of: '',
      year_of_items: [],
      year_of: '',
      selectedDepositId: -1,
      list_of_loan_savings: [],
      total: 0,
      //table props
      data_table_loading: false,
      headers: [
        {text: 'No.', value: 'no'},
        {text: 'Name', value: 'full_name'},
        {text: 'No. of Shares Subscribed', value: 'personal_ledger.no_of_shares'},
        {text: 'Amount Subscribe', value: 'personal_ledger.amount_subscribed'},
        {text: 'No. of Shares Paid', value: 'personal_ledger.no_of_shares_paid'},
        {text: 'Amount Paid-Up', value: 'personal_ledger.amount_paid_subscribed'},
      ],
    }
  },
  mounted() {
    this.get_list_of_coop_payable_summary_items()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['company_logo']),
    ...mapGetters('authentication', ['branch_id', 'branch', 'branch_address', 'branch_contact_no']),
  },
  watch: {
    branch_id: function () {
      this.can_print = false
      this.month_of = ''
      this.list_of_loan_savings = []
      this.total = '0'
      this.selected_month_of = 'NA'
    },
    search_member: function () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (this.search_member === '') {
          this.search_items = []
        } else {
          this.searching_search_items(this.search_member)
        }
      }, 500)
    },
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('transaction_months', ['retrieve_transaction_month', 'retrieve_all_transaction_year']),
    ...mapActions('expenses_summary', ['get_summary_expenses', 'update_expenses_encoded', 'get_expenses_particulars']),
    ...mapActions('members_information', ['list_of_declared_member', 'create_declared_member']),
    ...mapActions('members_information', ['search_all_members']),
    ...mapActions('share_capital', ['create_personal_ledger']),
    activerow(value) {
      this.data = value
      this.can_edit = true
      this.selectedDepositId = value.id;
    },
    searching(value) {
      this.search_member = value
    },
    searching_search_items(value) {
      this.search_all_members({
        search_word: value
      })
        .then(response => {
          this.search_items = response.data
        })
    },
    reset() {
      this.search_member = ''
      this.search_items = []
      this.member_information = {}
    },
    get_search_items_info() {
      if (this.search_items.length > 0) {
        var index = this.search_items.map(function (x) {
          return x.id;
        }).indexOf(this.search.id)
        if (index != -1) {
          this.member_information = this.search_items[index].member
        } else {
          this.reset()
        }
      } else {
        this.reset()
      }
    },
    save_bank_details() {
      this.saving = true
      this.alert = false
      const data = new FormData()
      data.append('member_id', this.member_information.id);
      this.create_declared_member(data)
        .then(response => {
          this.change_snackbar({
            show: true,
            color: 'success',
            text: response.data,
          })
          this.saving = false
          this.can_edit = false
          this.get_list_of_coop_payable_summary_items()
        })
        .catch(error => {
          this.alert = true
          this.alert_message = error
          this.saving = false
        })
    },
    save_bank_details2() {
      this.saving = true
      this.alert = false
      const data = new FormData()
      data.append('member_id', this.selectedDepositId);
      data.append('date', this.or_date);
      data.append('or_no', this.or_no);
      data.append('no_of_shares', this.no_of_share_sub);
      data.append('amount_subscribed', this.no_of_share_sub);
      data.append('no_of_shares_paid', this.no_of_shares_paid);
      data.append('amount_paid_subscribed', this.amount_paid_subscribed);
      data.append('amount', this.amount);
      this.create_personal_ledger(data)
        .then(response => {
          this.change_snackbar({
            show: true,
            color: 'success',
            text: response.data,
          })
          this.saving = false
          this.can_edit = false
          this.get_list_of_coop_payable_summary_items()
        })
        .catch(error => {
          this.alert = true
          this.alert_message = error
          this.saving = false
        })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    get_list_of_coop_payable_summary_items() {
      this.list_of_declared_member()
        .then((response) => {
          this.total = response.data.length
          this.list_of_loan_savings = response.data
          this.data_table_loading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    print() {
      var imgData = this.company_logo
      var payments_array = []

      var month = this.selected_month_of
      var total = this.total
      var totalno_of_shares = 0
      var totalamount_subscribed = 0
      var totalno_of_shares_paid = 0
      var totalamount_paid_subscribed = 0
      payments_array.push(
        [
          {text: 'No.', alignment: 'center', style: 'label'},
          {text: 'Name', alignment: 'center', style: 'label'},
          {text: 'No. of Shares Subscribed', alignment: 'center', style: 'label'},
          {text: 'Amount Subscribed', alignment: 'center', style: 'label'},
          {text: 'No. of Shares Paid', alignment: 'center', style: 'label'},
          {text: 'Amount Paid-Up', alignment: 'center', style: 'label'},
        ]
      )
      if (this.list_of_loan_savings.length > 0) {
        this.list_of_loan_savings.forEach(function (item, index) {
          totalno_of_shares += parseFloat(item.personal_ledger?item.personal_ledger.no_of_shares:0)
          totalamount_subscribed += parseFloat(item.personal_ledger?item.personal_ledger.amount_subscribed:0)
          totalno_of_shares_paid += parseFloat(item.personal_ledger?item.personal_ledger.no_of_shares_paid:0)
          totalamount_paid_subscribed += parseFloat(item.personal_ledger?item.personal_ledger.amount_paid_subscribed:0)
          payments_array.push(
            [
              {text: index + 1, alignment: 'center'},
              {text: item.full_name, alignment: 'left'},
              {text: item.personal_ledger?item.personal_ledger.no_of_shares:'', alignment: 'center'},
              {text: item.personal_ledger?item.personal_ledger.amount_subscribed:'', alignment: 'center'},
              {text: item.personal_ledger?item.personal_ledger.no_of_shares_paid:'', alignment: 'center'},
              {text: item.personal_ledger?item.personal_ledger.amount_paid_subscribed:'', alignment: 'center'},
            ]
          )
        })
      } else {
        payments_array.push(
          [
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
          ]
        )
      }

      payments_array.push(
        [
          {text: '', alignment: 'center'},
          {text: 'TOTAL', alignment: 'left'},
          {text: totalno_of_shares, alignment: 'center'},
          {text: totalamount_subscribed, alignment: 'center'},
          {text: totalno_of_shares_paid, alignment: 'center'},
          {text: totalamount_paid_subscribed, alignment: 'center'},
        ]
      )
      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: 'LETTER',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE SAVINGS & CREDIT COOPERATIVE',
                  {
                    text: 'Ground Floor, GL Emerald Building San Jose Digos City Davao del Sur 8002',
                    style: 'subheader'
                  },
                  {
                    text: 'C.D.A. REG. No. 9520-1011000000048747 CONTACT NO.: ' + this.branch_contact_no,
                    style: 'subheader'
                  },
                ],
                style: 'header'
              },
            ]
          },
          {text: 'LIST OF MEMBERS', style: 'title'},
          '================================================================================',
          {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: [30, 200, 60, 60, 60, 60],
              body: payments_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
        ],
        footer: {
          columns: [
            {
              text: 'Generated with Goodlife Savings & Credit Cooperative System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 9,
          },

          aa_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          bm_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cs_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          aa_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_placeholder: {
            margin: [15, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_for: {
            margin: [0, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_placeholder: {
            margin: [26, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_placeholder: {
            margin: [5, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          au_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
  }
}
</script>
